/* Collection listing — native Search & Discovery filters with AJAX.
   Filtering/sorting/relevance are server-side (URL ?filter.… params). The page works without
   JS (the GET form reloads); this script upgrades it to fetch-and-swap (no reload), keeps the
   browser URL in sync, drives the mobile drawer, and maps legacy ?series= links to the
   native Model filter. Events are delegated on the stable #shopForm so they survive swaps. */
(function(){
  var form=document.getElementById('shopForm');
  if(!form) return;

  function panelEl(){ return document.getElementById('shopFilters'); }
  function previewId(){ return new URLSearchParams(location.search).get('preview_theme_id'); }
  function withPreview(url){
    var p=previewId();
    if(p && url.indexOf('preview_theme_id=')<0){ url+=(url.indexOf('?')>=0?'&':'?')+'preview_theme_id='+encodeURIComponent(p); }
    return url;
  }

  /* ---------- mobile drawer (backdrop lives on <body>, survives swaps) ---------- */
  var bg=document.getElementById('filtBg');
  if(!bg){ bg=document.createElement('div'); bg.id='filtBg'; bg.className='filters__bg'; document.body.appendChild(bg); }
  function closeDrawer(){ var p=panelEl(); if(p) p.classList.remove('open'); bg.classList.remove('on'); }
  function openDrawer(){ var p=panelEl(); if(p) p.classList.add('open'); bg.classList.add('on'); }
  bg.addEventListener('click',closeDrawer);
  function revealToggle(){ var t=document.getElementById('filtToggle'); if(t) t.hidden=false; }
  revealToggle();

  /* ---------- AJAX apply ---------- */
  var ctrl=null;
  function buildUrl(){
    var params=new URLSearchParams();
    new FormData(form).forEach(function(val,key){ if(String(val).trim()!=='') params.append(key,val); });
    var qs=params.toString();
    return location.pathname+(qs?('?'+qs):'');
  }
  function applyForm(){ apply(buildUrl(), false); }

  function apply(url, fromPop){
    if(ctrl) ctrl.abort();
    ctrl=new AbortController();
    var grid=document.getElementById('shopGrid'); if(grid) grid.style.opacity='.45';
    fetch(withPreview(url),{signal:ctrl.signal,headers:{'X-Requested-With':'fetch'}})
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var fresh=doc.getElementById('shopForm');
        if(!fresh){ location.assign(withPreview(url)); return; }
        var wasOpen=!!(panelEl() && panelEl().classList.contains('open'));
        form.innerHTML=fresh.innerHTML;
        revealToggle();
        if(wasOpen) openDrawer();
        if(!fromPop) history.pushState({},'',withPreview(url));
      })
      .catch(function(err){ if(err.name!=='AbortError') location.assign(withPreview(url)); });
  }

  /* intercept the GET form submit (fired by requestSubmit on checkbox/sort change, Apply, Enter) */
  form.addEventListener('submit',function(e){ e.preventDefault(); applyForm(); });

  /* delegated clicks: drawer toggle/close + active-filter pills + clear-all */
  form.addEventListener('click',function(e){
    if(e.target.closest('#filtToggle')){ var p=panelEl(); (p&&p.classList.contains('open'))?closeDrawer():openDrawer(); return; }
    if(e.target.closest('#filtClose')){ closeDrawer(); return; }
    var link=e.target.closest('.filt-pill, .filt-clear');
    if(link){ e.preventDefault(); apply(link.getAttribute('href'), false); }
  });

  window.addEventListener('popstate',function(){ apply(location.pathname+location.search, true); });

  /* ---------- legacy ?series=<name> → native Model filter (old header links) ---------- */
  var legacy=new URLSearchParams(location.search).get('series');
  if(legacy){
    var want=legacy.trim().toLowerCase(), target=null, p=panelEl();
    if(p) p.querySelectorAll('.filt-chk input[type=checkbox]').forEach(function(cb){
      if(target) return;
      var span=cb.parentNode.querySelector('span');
      var txt=span ? (span.childNodes[0]?span.childNodes[0].textContent:span.textContent) : '';
      if(txt.trim().toLowerCase()===want) target=cb;
    });
    if(target){ target.checked=true; applyForm(); }
  }
})();

;(function(){
  try{
    var SHOW = 6;
    function enhance(root){
      var groups = (root||document).querySelectorAll('.filtg__b:not([data-more])');
      for(var g=0; g<groups.length; g++){
        var b = groups[g], labels = [];
        for(var i=0;i<b.children.length;i++){ if(b.children[i].tagName==='LABEL') labels.push(b.children[i]); }
        if(labels.length <= SHOW){ b.setAttribute('data-more','0'); continue; }
        b.setAttribute('data-more','1');
        for(var j=SHOW;j<labels.length;j++) labels[j].classList.add('filt-hidden');
        var hidden = labels.length - SHOW;
        var btn = document.createElement('button');
        btn.type='button'; btn.className='filt-more'; btn.textContent = '+ '+hidden+' more';
        (function(labels, btn, hidden){
          var collapsed = true;
          btn.addEventListener('click', function(){
            collapsed = !collapsed;
            for(var k=SHOW;k<labels.length;k++) labels[k].classList.toggle('filt-hidden', collapsed);
            btn.textContent = collapsed ? ('+ '+hidden+' more') : 'Show less';
          });
        })(labels, btn, hidden);
        if(b.parentNode) b.parentNode.insertBefore(btn, b.nextSibling);
      }
    }
    function init(){
      var panel = document.getElementById('shopFilters') || document;
      enhance(panel);
      if(window.MutationObserver && panel.nodeType===1){
        new MutationObserver(function(){ enhance(panel); }).observe(panel, {childList:true, subtree:true});
      }
    }
    if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
  }catch(e){}
})();
